//Utilities
import AppDispatcher from '../core/AppDispatcher.jsx';
import _ from 'lodash';
import { EventEmitter } from 'events';
import Validators from '../utils/Validators.js';
import InSpecieTransferConstants from '../constants/InSpecieTransferConstants.js';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import PortfolioRebateConstants from '../constants/PortfolioRebateConstants.js';
import PensionPaymentConstants from '../constants/PensionPaymentConstants';
import AutoRebalancingConstants from '../constants/AutoRebalancingConstants';
import PensionConstants from '../constants/PensionTypeConstants.js';
import Products from '../utils/Products.js';

import ContentService from '../services/ContentService';

import FundingYourProductHelper from '../utils/FundingYourProductHelper.js';
import InSpecieTransferHelper from '../utils/InSpecieTransferHelper.js';
import {getAssetAllocationsList} from '../apis/AssetAllocationsAPI.js';

//local variables
const CHANGE_EVENT = 'change';
const ActionTypes = InSpecieTransferConstants.ActionTypes;
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const AutoRebalancingActionTypes = AutoRebalancingConstants.ActionTypes;
const PensionActionTypes = PensionConstants.ActionTypes;

let _inSpecieAccounts = [];
let _fundingSummary = [];
let _externalFunds = [];
let _internalNonEligibleAccounts = [];
let _summaryErrors = [];
let _inlineErrors = [];
let _crossSectionDependencyMsg = [];
let _portfolioRebateData;
let _pensionPaymentDrawDownOption;
let _autoRebalancingOption;
let _inSpecieModel = _.cloneDeep(InSpecieTransferConstants.formModel);
let _hideDependentSections = false;
let _productId;
let _pensionType;

function updateStoreModel(fieldId, value) {
    let toHideDepSections = _hideDependentSections;
    if (fieldId === 'setUp' && value === ApplicationConstants.YesNoValues.NO) {
        _inSpecieModel = _.cloneDeep(InSpecieTransferConstants.formModel);
        toHideDepSections = false;
    } else if (fieldId === 'setUp' && value === ApplicationConstants.YesNoValues.YES) {
        _inSpecieModel[fieldId] = value;
        toHideDepSections = _externalFunds.length === 0 && _internalNonEligibleAccounts.length === 0;
    } else if (fieldId === 'externalAccountQuestion') {
        _inSpecieModel[fieldId] = value;
        clearErrors('istExternalAccountsQuestion');
        toHideDepSections = value === ApplicationConstants.YesNoValues.YES;
    } else {
        _inSpecieModel[fieldId] = value;
    }

    if (fieldId === 'setUp' || fieldId === 'externalAccountQuestion') {
        updateCrossSectionDependencyMsg(_hideDependentSections !== toHideDepSections);
    }
    _hideDependentSections = toHideDepSections;

    // get the asset allocations list for inspecie accounts whenever there is a change in the inspecie option
    getAssetAllocation();
}

function updateCrossSectionDependencyMsg(invAllocationChanged) {
    _crossSectionDependencyMsg = [];
    if (ApplicationConstants.FormModel.form.adviceFee.adviceFeeOption === ApplicationConstants.YesNoValues.YES) {
        _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.adviceFees, order: 5});
    }
    if (_portfolioRebateData) {
        if (_portfolioRebateData.portfolioRebateData.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION) {
            _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.portfolioRebate, order: 4});
        }
    }
    if (_pensionPaymentDrawDownOption === PensionPaymentConstants.DrawDownOption.CUSTOM) {
        _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.pensionPayment, order: 2});
    }
    if (_autoRebalancingOption === ApplicationConstants.YesNoValues.YES) {
        _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.autoRebalancing, order: 3});
    }
    if (invAllocationChanged) {
        _crossSectionDependencyMsg.push({content: ContentService.getContent().crossSectionHeaders.investmentAllocation, order: 1});
    }
}

function clearErrors(errorId) {
    Validators.clearErrorListForField(_inlineErrors, errorId);
}

function clearFundingdata() {
    _fundingSummary = [];
    _inSpecieAccounts = [];
    _externalFunds = [];
    _summaryErrors = [];
    _inlineErrors = [];
    _internalNonEligibleAccounts = [];
}

function mapFundingSummary(summary) {
    clearFundingdata();
    _fundingSummary = _.cloneDeep(summary);


    _.forEach(_fundingSummary,
        function(o) {
            let isInSpecieEligible;
            if(o.productId == InSpecieTransferConstants.eligibleInSpecieProducts.FirstChoiceEmployerSuper || o.selectedManualEntryProductId == InSpecieTransferConstants.eligibleInSpecieProducts.FirstChoiceEmployerSuper){
                 isInSpecieEligible = 
                (!Products.isPension(_productId) 
                || _pensionType !== PensionConstants.PensionTypeBenefits.ENTRY_DEATH ) &&
                (InSpecieTransferHelper.isInSpecieEligible(o.productId) || InSpecieTransferHelper.isInSpecieEligible(o.selectedManualEntryProductId)); 
            }else{
                 isInSpecieEligible = 
                (!Products.isPension(_productId) 
                ||( _pensionType !== PensionConstants.PensionTypeBenefits.ENTRY_DEATH &&
                    _pensionType !== PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT) ) &&
                (InSpecieTransferHelper.isInSpecieEligible(o.productId) || InSpecieTransferHelper.isInSpecieEligible(o.selectedManualEntryProductId)); 
            }
            
            if (FundingYourProductHelper.isInternal(o.rollOverType) && isInSpecieEligible) {
                _inSpecieAccounts.push(o);
            } else if (!FundingYourProductHelper.isInternal(o.rollOverType)) {
                _externalFunds.push(o);
            } else {
                _internalNonEligibleAccounts.push(o);
            }
        });
}

function loadFundingSummary(summary) {
    let isAtLeastOneInSpecieAccount = _inSpecieAccounts && (_inSpecieAccounts.length > 0);

    if (summary.length > 0) {
        mapFundingSummary(summary);
    } else {
        clearFundingdata();
    }

    if (isAtLeastOneInSpecieAccount !== _inSpecieAccounts && (_inSpecieAccounts.length > 0)) {
        // inspecie section is switching between visible and invisible
        _inSpecieModel = _.cloneDeep(InSpecieTransferConstants.formModel);
        _crossSectionDependencyMsg = [];
        _hideDependentSections = false;
    } else if ((_inSpecieAccounts && (_inSpecieAccounts.length > 0)) && _inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES) {
        // the funding summary list has changed but the inspecie section still remain visible
        _inSpecieModel = _.cloneDeep(InSpecieTransferConstants.formModel);
        updateCrossSectionDependencyMsg(_hideDependentSections);
        _hideDependentSections = false;
    }

    // get the asset allocations list for inspecie accounts whenever there is a change in the fundings
    getAssetAllocation();
}

function getFieldMapping(id) {
    return InSpecieTransferConstants.InSpecieTransferFieldMapping[id];
}

function validateSection() {
    if (_inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES) {
        let rules = {
            setUp: false,
            externalAccountQuestion: false
        }
        if (_externalFunds.length > 0 || _internalNonEligibleAccounts.length > 0) {
            rules.externalAccountQuestion = 'required';
        }
        var summaryErrors = [];
        var inlineErrors = [];
        summaryErrors = Validators.validateAll(_inSpecieModel, rules, InSpecieTransferConstants.InSpecieTransferAttributes, '', 'In specie transfer');
        inlineErrors = Validators.validateAll(_inSpecieModel, rules, InSpecieTransferConstants.InSpecieTransferAttributes);
        if (summaryErrors.length > 0) {
            _summaryErrors = [];
            _.forEach(summaryErrors,
                function(n) {
                    _summaryErrors.push({
                        clickable: n.clickable,
                        message: n.message,
                        id: getFieldMapping(n.id)
                    });
                });
        } else {
            _summaryErrors = [];
        }

        if (inlineErrors.length > 0) {
            _.forEach(inlineErrors,
                function(n) {
                    n.id = getFieldMapping(n.id);
                });
            _inlineErrors = inlineErrors;
        } else {
            _inlineErrors = [];
        }
    } else {
        _summaryErrors = [];
        _inlineErrors = [];
    }
}

function setPortfolioRebate(portfolioRebateData) {
    _portfolioRebateData = _.cloneDeep(portfolioRebateData);
}

function setPensionPaymentDrawDownOption(drawDownOption) {
    _pensionPaymentDrawDownOption = drawDownOption;
}

function setAutoRebalancing(data) {
    if (data.changedField === AutoRebalancingConstants.AutoRebalancingFields.AUTO_REBALANCING_OPTIONS) {
        _autoRebalancingOption = data.option.value;
    }
}

function retrieveInSpecieModel(form) {
    if (window.NOA.userContext.isAdviser) {
        loadFundingSummary(form.fundingYourProduct.fundingSources);
        _inSpecieModel = {
            setUp: _.get(form, 'inSpecieTransfer.setUp', null),
            externalAccountQuestion: _.get(form, 'inSpecieTransfer.externalAccountQuestion', null)
        };
    }
}

function getAssetAllocation() {
    let accounts = _.cloneDeep(_inSpecieAccounts);
    var investmentOptions = _.flatten(_.map(accounts, 'investmentOptions'));
    const inSpecieInvestmentOptionIds = _.pluck(investmentOptions, 'id');
    if (inSpecieInvestmentOptionIds && inSpecieInvestmentOptionIds.length > 0 && _inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES) {
        getAssetAllocationsList(_productId, inSpecieInvestmentOptionIds, true);
    }
}

function setProductId(productId) {
    _productId = productId;
}

function sortCrossSectionOrder() {
    _crossSectionDependencyMsg = _.sortBy(_crossSectionDependencyMsg, 'order');
}

function pensionTypeChanged(pensionType) {
    // when switch to Death benefit Or Pre-Retirement, in specie should be "No" and funding data have to be cleared    
    if (pensionType !== _pensionType &&
        pensionType === PensionConstants.PensionTypeBenefits.ENTRY_DEATH ) {
        _pensionType = pensionType;
        updateStoreModel('setUp', ApplicationConstants.YesNoValues.NO);
    } else {
        _pensionType = pensionType;
    }
}

class InSpecieTransferStoreClass extends EventEmitter {
    constructor() {
        super();
    }
    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getInSpecieAccounts() {
        return _inSpecieAccounts || [];
    }

    getInSpecieModel() {
        return _.cloneDeep(_inSpecieModel);
    }

    getIsThereExternalFunds() {
        return _externalFunds.length > 0 || _internalNonEligibleAccounts.length > 0;
    }

    getSummaryErrors() {
        return _summaryErrors;
    }

    getInlineErrors() {
        return _inlineErrors;
    }

    getInSpecieDecisions() {
        return _hideDependentSections;
    }

    getFormModel() {
        let formModel = {
            setUp: _inSpecieModel.setUp,
            externalAccountQuestion: _inSpecieModel.externalAccountQuestion,
            inSpecieAccounts: _inSpecieAccounts,
            externalFunds: _externalFunds,
            internalNonEligibleAccounts: _internalNonEligibleAccounts
        };
        return formModel;
    }

    getCrossSectionDependencyMsg() {
        sortCrossSectionOrder();
        return _crossSectionDependencyMsg;
    }

}

// Initialize the singleton to register with the
// dispatcher and export for React components
const InSpecieTransferStore = new InSpecieTransferStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
InSpecieTransferStore.dispatchToken = AppDispatcher.register((action) => {
    switch (action.actionType) {
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case ActionTypes.UPDATE_INSPECIE_MODEL:
            updateStoreModel(action.fieldId, action.value);
            break;
        case ApplicationActionTypes.IS_FUNDING_SUMMARY:
            loadFundingSummary(action.summary);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateSection();
            break;
        case ApplicationActionTypes.SEND_PORTFOLIO_REBATE_DETAILS:
            setPortfolioRebate(action.portfolioRebateData);
            break;
        case ApplicationActionTypes.SEND_PENSION_PAYMENT_DRAW_DOWN_OPTION:
            setPensionPaymentDrawDownOption(action.drawDownOption);
            break;
        case AutoRebalancingActionTypes.UPDATE_AUTO_REBALANCING:
            setAutoRebalancing(action.data);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            retrieveInSpecieModel(action.applicationData.form);
            break;
        case PensionActionTypes.SELECT_BENEFIT:
        case PensionActionTypes.SELECT_PENSION_TYPE:
            pensionTypeChanged(action.value);
            break;
        default:
            return true;
    }

    InSpecieTransferStore.emitChange();
    return true;
});

export default InSpecieTransferStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/InSpecieTransferStore.js